var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"mb-2 bg-white",attrs:{"pill":"","variant":_vm.variant},on:{"click":_vm.back}},[_c('feather-icon',{attrs:{"icon":"ArrowLeftIcon","size":"15"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }